<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"  />
  </div>
</template>

<script>
  export default {
    methods: {
      onGetKey() {
        return timeTransform(new Date(), 'YYYYmmDD');
      },
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      }
    },
    mounted() {
      let that = this;
      if (that.isMobile()) {
        window.location.href = webUrl() + '/mobile/';
      }
    },
  };
</script>

<style>

</style>
